import { withStyles } from "@material-ui/core/styles";
import Spinner from "./Spinner";
import styles from "./styles";

export default withStyles(styles)(Spinner);
